export default __webpack_public_path__ + "static/media/DwightSchrute.ec50c4b9.jpg";